export const isMobile = () => {
    return /Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)
  }

export default { 
    isMobile
}